<script setup>
import {
  StealieButton,
  StealieHeading,
  StealieOverline,
  StealieTextInput,
  StealieParagraph,
  StealieLink,
} from "@get-overalls/fe-stealie";
import { useRoute } from "vue-router";
import SignInLayout from "@/layouts/SignInLayout.vue";
import { useResetPassword } from "./composables/useResetPassword";
import FormError from "@/components/FormError.vue";

const route = useRoute();
const { formData, errors, submitError, handleSubmit } = useResetPassword(
  route.params.resetToken,
);
</script>

<template>
  <SignInLayout>
    <div>
      <div>
        <StealieOverline>Reset Password</StealieOverline>
      </div>
      <div class="col-span-4">
        <StealieHeading size="lg" class="mb-6 text-balance"
          >Set your new password</StealieHeading
        >
      </div>
      <form
        aria-label="Reset password form"
        method="post"
        novalidate
        class="flex flex-col gap-6"
        @submit.prevent="handleSubmit"
      >
        <div>
          <StealieTextInput
            v-model="formData.password"
            name="password"
            type="password"
            label="New password"
            autocomplete="new-password"
            required
            :error-message="errors.password"
          />
        </div>
        <div>
          <StealieTextInput
            v-model="formData.passwordConfirmation"
            name="passwordConfirmation"
            type="password"
            label="Confirm new password"
            autocomplete="new-password"
            required
            :error-message="errors.passwordConfirmation"
          />
        </div>
        <FormError v-if="submitError" :error="submitError" />
        <div>
          <StealieButton type="submit" class="mt-2 mb-6" full-width
            >Change my password</StealieButton
          >
        </div>
      </form>
      <div>
        <StealieParagraph size="sm" class="mb-4">
          New to Overalls?
          <StealieLink :to="{ name: 'SignUp' }" underline>Sign up</StealieLink>
        </StealieParagraph>
        <StealieParagraph size="sm">
          Already have an account?
          <StealieLink :to="{ name: 'SignIn' }" underline>Sign in</StealieLink>
        </StealieParagraph>
      </div>
    </div>
  </SignInLayout>
</template>
